import { render, staticRenderFns } from "./FellowshipFAQMentee.vue?vue&type=template&id=6d8a7d54&scoped=true"
import script from "./FellowshipFAQMentee.vue?vue&type=script&lang=js"
export * from "./FellowshipFAQMentee.vue?vue&type=script&lang=js"
import style0 from "./FellowshipFAQMentee.vue?vue&type=style&index=0&id=6d8a7d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a7d54",
  null
  
)

export default component.exports